import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderPen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 21L22.5 15.5L19.5 12.5L14 18V21H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V11.6914L21 9.69141V7H12.5859L9.58594 4H3V19H11V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderPen.js.map